<template>
  <tbody>
    <tr v-for="(item, i) in items" :key="item.id" class="text-xs-center hovereable" @click="editItemWithEvent($event, item.id)">
      <td width="10%">
        <v-icon x-large class="k-orange-linear-text text--darken-2">http</v-icon>
      </td>
      <td class="text-xs-left">
        {{ item.domain }}
      </td>
      <td></td>
      <td  width="15%">
        <v-chip medium :class="{'white--text':true, 'green':item.status === 'Activo', 'red':item.status === 'Inactivo', 'blue lighten-2':item.status === 'Pendiente'}">
          <v-icon class="pr-2 white--text" small>{{item.status === 'Activo' ? 'fas fa-check' : item.status === 'Inactivo' ? 'fas fa-times' : 'fas fa-clock'}}</v-icon>
          {{item.status}}
        </v-chip>
      </td>
      <td v-if="checkCreate()" width="15%" class="text-xs-right">
        <v-menu bottom offset-y>
          <v-btn slot="activator" color="grey darken-2" small flat fab>
            <v-icon>fas fa-ellipsis-v</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="changeStatus(item.id, item.status, 'domains')">
              <v-list-tile-title>
                <template v-if="item.status === 'Activo'">
                  Desactivar
                </template>
                <template v-else-if="item.status === 'Inactivo' || item.status === 'Pendiente'">
                  Activar
                </template>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="editItemWithEvent(null, item.id)">
              <v-list-tile-title>Editar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteItem(item.id, `el dominio ${item.domain}`)">
              <v-list-tile-title>Eliminar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </tbody>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableList';
import permissionsMixin from '@/mixins/permissions';

export default {
  props: ['items'],
  mixins: [
    dataTableMixin,
    permissionsMixin,
  ],
  methods: {
    checkCreate(){
      return this.checkPermissions([
        'create_domains',
      ]);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/domain/DomainList.vue